import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const deleteBusCourse = id => {
  return api.delete(`/admin/bus-courses-v2/${id}`);
};

export const useDeleteBusCourseMutation = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: deleteBusCourse,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.resetQueries();
    },
    ...restConfig,
  });
};
